import React, { useEffect } from "react";
import MasterComponent from "../../../components/Forms";
import { MasterConfigs } from "../../../interfaces/entity";
import CommonView, { CommonViewProps } from "../../../components/CommonView/CommonView";
import { Space, Typography } from "antd";
import { useDispatch } from "react-redux";
const { Title, Text } = Typography;

const Assets = () => {
    const [selectedId, setSelectedId] = React.useState(null);
    const [load, setLoad] = React.useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        if (selectedId) {
            dispatch({
                type: 'REFRESH_TABLE',
                refreshTable: true,
                query: { assetType: selectedId }
            })
        }
    }, [selectedId]);

    const config: MasterConfigs = {
        api: () => '/asstes-types',
        title: 'Assets Types',
        modalTitle: (action) => `${action} ${config.title}`,
        getColumns: () => [],
        onRefresh: () => setLoad(true),
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Code',
                name: 'code',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Code' }]
            },
            {
                label: 'Description',
                name: 'description',
                type: 'textarea',
                span: 16
            },
        ],
        actions: [{ actionType: 'Add', name: 'Add' }],
    }

    const assetsTypes: MasterConfigs = {
        api: () => `/assets`,
        title: 'Assets Types',
        apiParams: { assetType: selectedId },
        modalTitle: (action) => `${action} ${assetsTypes.title}`,
        actions: [{ actionType: 'Add', name: 'Add' }],
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: 'Asset Id',
                dataIndex: 'assetId',
                key: 'assetId',
            },
            {
                title: 'Condition',
                dataIndex: 'condition',
                key: 'condition',
                render: (e) => e.name
            },
            {
                title: 'Purchase Date',
                dataIndex: 'purchaseDate',
                key: 'purchaseDate',
                render: (date) => {
                    return new Date(date).toDateString();
                }
            },
            {
                title: 'Warrenty Expiry',
                dataIndex: 'warranty',
                key: 'warranty',
                render: (date) => {
                    return new Date(date).toDateString();
                }
            },
            {
                title: 'Location',
                dataIndex: 'location',
                key: 'location',
                render: (e) => e.name
            },
            {
                title: 'Size',
                dataIndex: 'size',
                key: 'size',
            }
        ],
        getFormColumns: () => [
            {
                label: 'Name',
                name: 'name',
                type: 'text',
                rules: [{ required: true, message: 'Please enter name' }]
            },
            {
                label: 'Model Number',
                name: 'modelnumber',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Model Number' }]
            },
            {
                label: 'Color',
                name: 'color',
                type: 'text',
            },
            {
                label: 'Size',
                name: 'size',
                type: 'text',
            },
            {
                label: 'Asset Number Series',
                name: 'assetNumberSeries',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select Asset Id' }]
            },
            {
                label: 'Condition',
                name: 'condition',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select Condition' }]
            },
            {
                label: 'Location',
                name: 'location',
                type: 'select',
                isCombo: true,
                rules: [{ required: true, message: 'Please select Location' }]
            },
            {
                label: 'Purchase Price',
                name: 'purchasePrice',
                type: 'text',
                rules: [{ required: true, message: 'Please enter Purchase Price' }]
            },
            {
                label: 'Purchase Date',
                name: 'purchaseDate',
                type: 'date',
                rules: [{ required: true, message: 'Please select Purchase Date' }]
            },
            {
                label: 'Warranty Expiry',
                name: 'warranty',
                type: 'date',
                rules: [{ required: true, message: 'Please select Warranty Expiry' }]
            },
            {
                label: 'Bill',
                name: 'bill',
                type: 'file',
                uploadProps: { accept: 'application/pdf', listType: 'text', maxCount: 1 },
                rules: [{ required: true, message: 'Please upload Bill' }]
            },
            {
                label: 'Photos',
                name: 'photos',
                type: 'file',
                span: 24,
                uploadProps: { multiple: true, accept: 'image/*', listType: 'picture-card', maxCount: 5 },
                rules: [{ required: true, message: 'Please upload Photos' }]
            }
        ],
        combo: [
            {
                api: '/assets-number-series',
                name: 'assetNumberSeries',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                api: '/assets-condition',
                name: 'condition',
                idKey: '_id',
                render: (e) => e.name
            },
            {
                api: '/locations',
                name: 'location',
                idKey: '_id',
                render: (e) => e.name
            }
        ]
    }

    const commonViewProps: CommonViewProps = {
        config: config,
        listProps: { reload: load, onLoaded: () => setLoad(false) },
        componentConfig: {
            title: 'Assets Types',
            subTitle: 'Managing Asset Types in an Asset Management System',
            cardTitle: 'Assets Types',
            buttonName: 'Add Asset Type',
            emptyDescription: 'No Category found',
            customHeading: (record) => <Space direction="vertical" className="w-full">
                <Title level={5} className="!mb-[0px]" style={{ lineHeight: 1 }}>{record.name}</Title>
                <Text type="secondary">{record?.description}</Text>
            </Space>,
            renderComponent: (record) => <MasterComponent config={assetsTypes} />,
            renderListItem: (item) => {
                return <>
                    <Title level={5} style={{ lineHeight: 1.2, marginBottom: 0 }}>{item.name}</Title>
                    <Text type="secondary">{item?.code}</Text>
                </>
            },
            selectedItemId: (id) => setSelectedId(id),
        }
    }

    return <CommonView {...commonViewProps} />
}

export default Assets; 